export default __webpack_public_path__ + "static/media/prize-1-bm.afc54156.webp";